import { DimensionsObject } from '../CustomFacets/SizeFacet/CustomSizeFields'

const sizePresets = {
  default: {
    heightMin: 0,
    heightMax: 0,
    widthMin: 0,
    widthMax: 0,
  },
  small: {
    title: 'Small',
    cm: {
      heightMin: 0,
      heightMax: 51,
      widthMin: 0,
      widthMax: 51,
    },
    in: {
      heightMin: 0,
      heightMax: 20,
      widthMin: 0,
      widthMax: 20,
    },
  },
  medium: {
    title: 'Medium',
    cm: {
      heightMin: 51,
      heightMax: 97,
      widthMin: 51,
      widthMax: 97,
    },
    in: {
      heightMin: 20,
      heightMax: 38,
      widthMin: 20,
      widthMax: 38,
    },
  },
  large: {
    title: 'Large',
    cm: {
      heightMin: 97,
      heightMax: 152,
      widthMin: 97,
      widthMax: 152,
    },
    in: {
      heightMin: 38,
      heightMax: 60,
      widthMin: 38,
      widthMax: 60,
    },
  },
  oversized: {
    title: 'Oversized',
    cm: {
      heightMin: 152,
      heightMax: 2540,
      widthMin: 152,
      widthMax: 2540,
    },
    in: {
      heightMin: 60,
      heightMax: 1000,
      widthMin: 60,
      widthMax: 1000,
    },
  },
}

const validWidthState = (
  state: DimensionsObject // Valid if NO Min & Max || Min & Min=0, Max, Min < Max
) =>
  (!state.widthMin && !state.widthMax) ||
  ((state.widthMin || state.widthMin === 0) && state.widthMax && state.widthMin <= state.widthMax)

const validHeightState = (
  state: DimensionsObject // Valid if NO Min & Max || Min & Min=0, Max, Min < Max
) =>
  (!state.heightMin && !state.heightMax) ||
  ((state.heightMin || state.heightMin === 0) &&
    state.heightMax &&
    state.heightMin <= state.heightMax)

export const validateState = (state: DimensionsObject) => {
  const widthError = !validWidthState(state)
  const heightError = !validHeightState(state)
  return {
    widthError,
    heightError,
  }
}

export const getDimension = (size: string, measurementUnit: string): Record<string, any> =>
  !size || !measurementUnit || !sizePresets[size] || !sizePresets[size][measurementUnit]
    ? sizePresets.default
    : {
        currentSize: size, // ...sizePresets[size][measurementUnit], // Prefill with selected value small => 20 x 20
      }
